module.exports = __webpack_public_path__ + "b563fa11b5475764b56531f06d05da41.svg";